import api from "./API";

const getStoredUser = () => {
  try {
    const raw = localStorage.getItem("user");
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    console.error("habitsApi: erro ao ler usuario salvo", error);
    return null;
  }
};

const getUserId = () => {
  const user = getStoredUser();
  return user?.id ?? user?.userId ?? user?.id_usuario ?? null;
};

export const toYmd = (date) => {
  const source = date instanceof Date ? date : new Date(date);
  const year = source.getFullYear();
  const month = String(source.getMonth() + 1).padStart(2, "0");
  const day = String(source.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const parseCollection = (response) => {
  if (Array.isArray(response?.data)) return response.data;
  if (response?.data?.status === false) {
    throw new Error(response?.data?.message || "Nao foi possivel carregar os habitos.");
  }
  return (
    response?.data?.records ||
    response?.data?.record ||
    response?.data?.data ||
    response?.data?.habitos ||
    response?.data?.items ||
    response?.data?.rows ||
    []
  );
};

const parsePayload = (response) => {
  if (response?.data?.status === false) {
    throw new Error(response?.data?.message || "Nao foi possivel processar a operacao.");
  }
  return response?.data?.record || response?.data?.data || response?.data || null;
};

const normalizeHabit = (habit) => ({
  id: habit?.id,
  nome: habit?.nome || habit?.name || "Habito sem nome",
  tipo: habit?.tipo || "simples",
  ativo: habit?.ativo ?? true,
  frequencia_tipo: habit?.frequencia_tipo || habit?.frequencia || "todos_os_dias",
  dias_semana: Array.isArray(habit?.dias_semana)
    ? habit.dias_semana.map(Number)
    : Array.isArray(habit?.weekdays)
      ? habit.weekdays.map(Number)
      : [],
  periodo_dia: habit?.periodo_dia || "qualquer_horario",
  categoria: habit?.categoria || "",
  pilar: habit?.pilar || habit?.pillar || "",
  habito_ancora: habit?.habito_ancora || habit?.anchor_habit || habit?.ancora || "",
  grupo_rotina: habit?.grupo_rotina || habit?.rotina || "",
  meta_quantidade: habit?.meta_quantidade ?? habit?.meta ?? "",
  meta_unidade: habit?.meta_unidade || "",
  periodo_meta: habit?.periodo_meta || "dia",
  ordem: habit?.ordem ?? 0,
  concluido:
    habit?.concluido ??
    habit?.done ??
    habit?.registro?.concluido ??
    habit?.concluido_hoje ??
    false,
  valor_realizado:
    habit?.valor_realizado ??
    habit?.registro?.valor_realizado ??
    habit?.realizado ??
    "",
  streak_atual: habit?.streak_atual ?? habit?.streak ?? 0,
});

export const getHabitsForDate = async (date) => {
  const userId = getUserId();
  const params = new URLSearchParams({ data: toYmd(date) });
  if (userId) {
    params.set("id_usuario", String(userId));
  }

  const response = await api.get(`/habitos?${params.toString()}`);
  return parseCollection(response).map(normalizeHabit);
};

export const getHabitsSummary = async (range = "7d", date = new Date()) => {
  const userId = getUserId();
  const params = new URLSearchParams({ range, data: toYmd(date) });
  if (userId) {
    params.set("id_usuario", String(userId));
  }

  const response = await api.get(`/habitos/summary?${params.toString()}`);
  const payload = parsePayload(response) || {};
  return {
    completedToday:
      payload.completedToday ??
      payload.concluidas_hoje ??
      payload.completed_today ??
      payload.resumo?.concluidas_hoje ??
      0,
    totalToday:
      payload.totalToday ??
      payload.total_hoje ??
      payload.total_today ??
      payload.resumo?.total_hoje ??
      0,
    currentStreak:
      payload.currentStreak ??
      payload.sequencia_atual ??
      payload.current_streak ??
      payload.resumo?.sequencia_atual ??
      0,
    consistency:
      payload.consistency ??
      payload.consistencia_7_dias ??
      payload.consistencia ??
      payload.completion_rate ??
      payload.resumo?.consistencia ??
      0,
    series:
      payload.series ||
      payload.linha_7_dias ||
      payload.serie ||
      payload.days ||
      payload.dias ||
      [],
  };
};

export const getHabitsHeatmap = async (year) => {
  const userId = getUserId();
  const params = new URLSearchParams({ year: String(year) });
  if (userId) {
    params.set("id_usuario", String(userId));
  }

  const response = await api.get(`/habitos/heatmap?${params.toString()}`);
  const payload = parsePayload(response) || {};
  const records = payload.days || payload.dias || payload.records || payload.data || [];
  return Array.isArray(records)
    ? records.map((day) => ({
        ...day,
        data: day?.data || day?.date || day?.data_referencia,
        percentual: Number(day?.percentual ?? day?.percent ?? day?.valor ?? day?.intensidade ?? 0),
      }))
    : [];
};

export const createHabit = async (payload) => {
  const userId = getUserId();
  const response = await api.post("/habitos", {
    ...payload,
    id_usuario: payload?.id_usuario ?? userId ?? undefined,
  });
  return parsePayload(response);
};

export const updateHabit = async (id, payload) => {
  const userId = getUserId();
  const response = await api.put(`/habitos/${id}`, {
    ...payload,
    id_usuario: payload?.id_usuario ?? userId ?? undefined,
  });
  return parsePayload(response);
};

export const toggleHabit = async (id, payload) => {
  const userId = getUserId();
  const response = await api.patch(`/habitos/${id}/toggle`, {
    ...payload,
    id_usuario: payload?.id_usuario ?? userId ?? undefined,
  });
  return parsePayload(response);
};
